import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import PhoneInput from '../ui/PhoneInput';
import { isValidMobile } from '../../utils/phone';
import { clearPendingBookingCache } from '../../utils/pendingBooking';

const LoginPopup = ({ onClose, proceedToCoupen, onClose1}) => {
  const [mobile, setMobile] = useState(''); // the 10 digits, without +91
  const [showMobileErrors, setShowMobileErrors] = useState(false);
  const [isOtpSend, setIsOtpSend] = useState(false);
  const [otp, setOtp] = useState('');
  const userType = sessionStorage.getItem('userType')
  const [isChecked, setIsChecked] = useState(false);
  const [verifyOtpToken, setVerifyOtpToken] = useState('');
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const senOtpEmail = async (e) => {
    e.preventDefault();
    if (!isValidMobile(mobile)) {
      setShowMobileErrors(true);
      toast('Please enter a valid 10-digit mobile number', { type: 'warning' });
      return;
    }
    if(!isChecked){
      toast(`Please check the box before proceeding`, { type: 'warning' });
      return;
    }
    if (isSendingOtp) return;
    setIsSendingOtp(true);
    try {
      let response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/send-otp`, { phone:mobile });
      if (response.data.message) {
        toast(`${response.data.message}`, { type: 'success' });
        setVerifyOtpToken(response.data.otpVerifyToken);
        setIsOtpSend(true);
      }
    } catch (error) {
      console.error(error);
      // e.g. "Too many OTP requests..." (429) or "Please enter a valid mobile number" (400)
      toast(error?.response?.data?.message || 'Unable to send the OTP. Please try again.', { type: 'error' });
    } finally {
      setIsSendingOtp(false);
    }
  };

  const createNewAccount = async (e) => {
    e.preventDefault();
    if (isVerifyingOtp) return;
    setIsVerifyingOtp(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/user-verify`,
        { otp, userType },
        {
          headers: {
            Authorization: `Bearer ${verifyOtpToken}`,
          },
        }
      );
      if (response.data.loginToken) {
        localStorage.setItem('loginToken', response.data.loginToken);
        clearPendingBookingCache(); // this account may have a payment awaiting a session time
        toast(`${response.data.message}`, { type: 'success' });
        if (!onClose1) {
          onClose();
        }
        if (proceedToCoupen) {
          proceedToCoupen();
        }
        if (onClose1) {
          onClose1();
        }
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      toast(`${errorMessage}`, { type: 'error' });
      console.error(error);
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  const handleKeyPress1 = (event) => {
    if (event.key === 'Enter') {
      createNewAccount(event);
    }
  };

  const inputClass =
    'w-full rounded-none border border-forest/15 bg-white px-4 py-3.5 text-[15px] text-forest-deepest placeholder:text-forest-deepest/35 focus:border-brand-accent focus:outline-none';

  return (
    <>
      <ToastContainer />
      <Modal onClose={onClose}>
        {!isOtpSend ? (
          <form onSubmit={senOtpEmail}>
            <h2 className="text-center font-serif text-2xl italic text-forest-deepest">Welcome to Bhavishyavani</h2>
            <p className="mt-2 text-center text-sm font-medium text-forest-deepest/60">
              Enter your mobile number
            </p>
            <hr className="my-6 border-forest/10" />
            <PhoneInput
              id="login-mobile"
              value={mobile}
              onChange={setMobile}
              showErrors={showMobileErrors}
              inputClassName={inputClass}
              prefixClassName="border-forest/15 bg-canvas text-forest-deepest/70"
              placeholder="10-digit mobile number"
              autoFocus
            />
            <label className="mt-4 flex items-center gap-2.5 text-sm text-forest-deepest/70">
              <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} className="h-4 w-4 accent-brand-accent" />
              This is my active WhatsApp number
            </label>
            <div className="mt-6 flex items-center justify-between gap-3">
              <Button type="button" variant="outline-dark" onClick={onClose}>
                Close
              </Button>
              <Button type="submit" variant="primary-dark" loading={isSendingOtp}>
                Continue
              </Button>
            </div>
          </form>
        ) : (
          <form onSubmit={createNewAccount}>
            <h2 className="text-center font-serif text-2xl italic text-forest-deepest">Verify Your Account</h2>
            <p className="mt-3 text-center text-sm text-forest-deepest/60">
              An OTP has been sent to your <strong>WhatsApp number</strong>. Please enter it to continue.
            </p>
            <hr className="my-6 border-forest/10" />
            <input
              value={otp}
              placeholder="Enter code"
              onChange={(e) => setOtp(e.target.value)}
              onKeyPress={handleKeyPress1}
              className={inputClass}
              required
            />
            <div className="mt-6 flex items-center justify-between gap-3">
              <Button type="button" variant="outline-dark" onClick={onClose}>
                Close
              </Button>
              <Button type="submit" variant="primary-dark" loading={isVerifyingOtp}>
                Continue
              </Button>
            </div>
          </form>
        )}
      </Modal>
    </>
  );
};

export default LoginPopup;
